<template>
    <div class="info-box">
        <el-row class="content-head">
            <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item class="msgitem" >访客管理系统</el-breadcrumb-item>
                </el-breadcrumb>
                </div>
            </el-col>
        </el-row>
        <div class="box-head">
            <!-- <el-steps :active="curIndex" finish-status="success" process-status="finish" align-center>
                <el-step title="基本信息" description=""></el-step>
                <el-step title="扩展信息" description=""></el-step>
                <el-step title="资格证书" description=""></el-step>
            </el-steps> -->
        </div>
        <div class="box-main work-add">
            <el-form ref="form" :model="form" :rules="rules" label-width="200px" >
                <div style="width:100%;display:flex;position: relative;flex-wrap: wrap;">
                    <p style="width:100%;height:5vh;position: relative;border-bottom: 1px solid #ddd;display: flex;align-items: center;padding: 0 1vw;">访客信息录入</p>
                    
                    <div style="width:50%;height:auto;position: relative;padding:1vh 0 0 1vw;">
                        <el-form-item label="身份证阅读器类型：" >
                            <!--v-if="personId==''" -->
                            <el-select v-model="form.mach" placeholder="请选择" > 
                                <el-option label="华视电子-CVR-100U/100UC" value="1"></el-option>
                                <el-option label="身份证读卡器" value="2"></el-option>
                            </el-select>
                            <!-- <el-button type="text" @click="downDrive" v-if="form.mach && form.mach!=''" style="margin-left:5px;">驱动下载</el-button> -->
                            <el-dropdown @command="downDrive"  v-if="form.mach && form.mach == 1">
                                <span class="el-dropdown-link" style="margin-left:1vw;">
                                    <el-button type="text" @click="downDrive">驱动下载</el-button><i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="a">识别机驱动</el-dropdown-item>
                                    <el-dropdown-item command="b">USB驱动</el-dropdown-item>
                                    <el-dropdown-item command="c">安装说明</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <el-dropdown @command="downDrive"  v-if="form.mach && form.mach == 2">
                                <span class="el-dropdown-link" style="margin-left:1vw;">
                                    <el-button type="text" @click="sfzDownDrive">驱动下载</el-button><i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                            </el-dropdown>
                            <el-button @click="readCard" v-if="form.mach && form.mach == 1" size="medium" style="border:1px solid #409EFF;color:#409EFF;margin-left:2vw;">读卡</el-button>
                             <el-button @click="readCardNew" v-if="form.mach && form.mach == 2" size="medium" style="border:1px solid #409EFF;color:#409EFF;margin-left:2vw;">读卡</el-button>
                        </el-form-item>
                          <el-form-item label="姓名：" prop="name" disabled>
                            <el-input v-model="form.name" ></el-input>
                        </el-form-item>
                        <el-form-item label="身份证号：" prop="idCard" disabled>
                            <el-input v-model="form.idCard" ></el-input>
                        </el-form-item>
                        <el-form-item label="手机号码：" prop="phone">
                            <el-input v-model="form.phone" ></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="性别：" prop="sex">
                            <el-input v-model="form.sexName" ></el-input>
                        </el-form-item> -->
                        <!-- <el-form-item label="出生日期：" prop="birthday">
                            <el-date-picker v-model="form.birthday" value-format="yyyy-MM-dd"  type="date" placeholder="选择日期"></el-date-picker>
                        </el-form-item> -->
                         <el-form-item label="门禁卡号：">
                            <el-input v-model="form.icCard" ></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="发证机关：" prop="issuing">
                            <el-input v-model="form.issuing" ></el-input>
                        </el-form-item> -->
                       <el-form-item label="身份证头像：">
                            <div style="display:flex;">
                                <img v-if="form.idCardPhoto64 && form.idCardPhoto64!=''" :src="'data:image/jpg;base64,'+form.idCardPhoto64" style="width:9vh;height:10vh;margin-right:1vw;" />
                                <img v-else-if="form.idCardPhoto && form.idCardPhoto!=''" :src="form.idCardPhoto" style="width:9vh;height:10vh;margin-right:1vw;" />
                                <img v-else src="../../assets/image/default_user.png" style="width:9vh;height:10vh;margin-right:1vw;" />
                            </div>
                        </el-form-item>
                           <el-form-item  label="采集照片：" prop="facePhoto64">
                            <div style="display:flex;">
                                <img v-if="form.facePhoto64 && form.facePhoto64!=''" :src="form.facePhoto64" style="width:9vh;height:10vh;margin-right:1vw;"  />
                                <img v-else-if="form.facePhoto && form.facePhoto!=''" :src="form.facePhoto" style="width:9vh;height:10vh;margin-right:1vw;"  />
                                <img v-else src="../../assets/image/default_user.png" style="width:9vh;height:10vh;margin-right:1vw;" />
                                <div>
                                     <el-button icon="el-icon-camera" class="photoBtn" size="small" @click="photoFun" style="margin-top: 12px;">拍照</el-button>
                                    <el-upload
                                        class="avatar-uploader"
                                        action="#"
                                        accept=".jpg"
                                        :on-change="file => getFile(file)"
                                        :show-file-list="false"
                                        :on-success="fileSuccess"
                                        :auto-upload="false">
                                        <el-button size="small" class="photoBtn" icon="el-icon-paperclip">选择文件</el-button>
                                    </el-upload>
                                   
                                </div>
                            </div>
                        </el-form-item>
                        <!-- <el-form-item v-else label="采集照片：">
                            <div style="display:flex;">
                                <img v-if="form.facePhoto64 && form.facePhoto64!=''" :src="form.facePhoto64" style="width:9vh;height:10vh;margin-right:1vw;"  />
                                <img v-else-if="form.facePhoto && form.facePhoto!=''" :src="form.facePhoto" style="width:9vh;height:10vh;margin-right:1vw;"  />
                                <img v-else src="../../assets/image/default_user.png" style="width:9vh;height:10vh;margin-right:1vw;" />
                                <div>
                                    <el-button icon="el-icon-camera" class="photoBtn" size="small" @click="photoFun" style="margin-top: 12px;">拍照</el-button>
                                    <el-upload
                                        class="avatar-uploader"
                                        action="#"
                                        accept=".jpg"
                                        :on-change="file => getFile(file)"
                                        :show-file-list="false"
                                        :on-success="fileSuccess"
                                        :auto-upload="false">
                                        <el-button size="small" class="photoBtn" icon="el-icon-paperclip">选择文件</el-button>
                                    </el-upload>
                                 
                                </div>
                            </div>
                        </el-form-item> -->
                        <el-form-item label="开始时间：" prop="startDate">  
                         <el-date-picker type="datetime"  placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss" v-model="form.startDate" ></el-date-picker>              
                        </el-form-item>
                          <el-form-item label="结束时间：" prop="endDate">   
                         <el-date-picker type="datetime"  placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss" v-model="form.endDate" ></el-date-picker>
                        </el-form-item>
                        <!-- <el-form-item label="门禁卡号：">
                            <el-input v-model="form.icCard"></el-input>
                        </el-form-item> -->
                    </div>
                    <!-- <div v-if="form.teamsId && form.teamsId!=''" style="width:100%;height:auto;position: relative;padding:1vh 0 0 1vw;">
                        <el-form-item :label="formItemName" prop="workType">
                            <div style="width:100%;display:flex;flex-wrap:wrap;padding-top:6px;">
                                <p v-for="(item,index) in typeList" :key="index" class="type-item" :class="(form.workType==item.value?'selIndex':'')" @click="subWorkType(item)">{{item.label}}</p>
                            </div>
                        </el-form-item>
                    </div> -->
                </div>
            </el-form>
            <div style="width:100%;height:8vh;position: relative;display:flex;justify-content: center;align-items: center;border-top: 1px dashed #ddd;">
                <el-button  style="margin:0 1vh;padding:1vw 2vw;border: 1px solid #ccc;" @click="ediut" >取消</el-button>
                <el-button v-if="!isSubmit" style="margin:0 1vh;padding:1vw 2vw;border: 1px solid #0264F2;background-color:#0480F7;color:#fff;" @click="submitForm('form')">确定</el-button>
                <el-button v-else style="margin:0 1vh;padding:1vw 2vw;border: 1px solid #0264F2;" disabled>确定</el-button>
            </div>
        </div>
        <el-dialog title="拍照" custom-class="dialog-photo" center :visible.sync="photoVis" width="700px" :close-on-click-modal="false">
            <div style="width:100%;height:300px;position: relative;display:flex;">
                <div style="width:50%;height:100%;padding:10px;border:1px solid #ddd;box-shadow: 0 0 3px 1px #ddd;">
                    <video id="v" style="width:100%;height:100%;"></video>
                </div>
                <div style="width:50%;height:300px;display:flex;align-content: center;align-items: center;margin-left:10px;background: rgb(246 246 246);border-radius: 5px;justify-content: center;">
                    <img :src="photoImg" style="max-width:100%;max-height:100%;position: relative;" />
                </div>
                <canvas id="canvas" style="display:none;"></canvas>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="takePhotos" style="width: 200px;height: 50px;color: #409eff;">拍照</el-button>
                <el-button type="primary" @click="photoSubmit" style="width: 200px;height: 50px;">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import base from '../../untils/base'
import myHttp from '../../untils/port'
import util from '../../untils/util'
export default {
    data(){
        var checkPhone = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('手机号不能为空'));
            } else {
                var reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
                // console.log(reg.test(value));
                if (reg.test(value)) {
                    callback();
                } else {
                    return callback(new Error('请输入正确的手机号'));
                }
            }
        };
        return{
            curIndex:0,
            form:{
                idCard:'',
                name:'',
                address:'',
                issuing:'',
                startDate:'',
                endDate:'',
                idCardPhoto64:'',
                facePhoto64:'',//近照
                projectEndId:'',
                teamsId:'',
                teamLeader:'',
                workType:'', //岗位/工种
                projectId:'',
                bankCard:'',
                icCard:'',//卡号
                // cardNumber:'',//卡号
                phone:'',
             
                eduType:'',//学历,
               
               
            },
            rules:{
                phone:[
                    { required: true, message: '请输入手机号码', trigger: 'blur' },
                    {validator: checkPhone, trigger: 'blur'}
                ],
                idCard:[
                    {required: true, message: '请输入身份证', trigger: 'blur'}
                ],
                name:[
                    {required: true, message: '请输入姓名', trigger: 'blur'}
                ],
                // sex:[
                //     {required: true, message: '请输入性别', trigger: 'blur'}
                // ],
                // nation:[
                //     {required: true, message: '请输入民族', trigger: 'blur'}
                // ],
                // birthday:[
                //     {required: true, message: '请选择出生日期', trigger: 'change'}
                // ],
                // address:[
                //     {required: true, message: '请输入地址', trigger: 'blur'}
                // ],
                // issuing:[
                //      {required: true, message: '请输入发证机关', trigger: 'blur'}
                // ],
                // teamsId:[
                //     {required: true, message: '请选择班组', trigger: 'change'}
                // ],
                // workType:[
                //     {required: true, message: '请选择工种', trigger: 'change'}
                // ],
                // projectEntId:[
                //      {required: true, message: '请选择参建单位', trigger: 'change'}
                // ],
                facePhoto64:[
                    {required: true, message: '请选择近照', trigger: 'change'}
                ],
            },
            httpCtx:base.httpCtx,
            entList:[],
            teamsList:[],
            typeList:[],
            formItemName:'',
            teamLeader:false,//判断是否是班组长
            uploadUrl:base.url + '/upload/uploadPhoto', //上传地址
            uploadHead:{  //上传接口header
                accessToken:util.session.get('token')
            },
            isSubmit:false,//判断是否提交

            //拍照
            photoVis:false,
            videoPlaying:false,
            photoImg:'',
            video:undefined,
            listData:[],
            //判断是否是修改
            personId:'',
            loading:false,//提交加载
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        // this.getEntList()
        var params = this.$route.params
        if(params.id!='0'){
            this.personId = params.id
            // this.getInfo(params.id)
        }
        // this.getWorkerType()
    },
    methods:{
         ediut(){
         this.$router.push({path:'/visitorPro'})
    },
        //获取详情
        // getInfo(id){
        //     var that = this
        //     myHttp.selectTeamsPersonDetails({
        //         personId:id,
        //         projectId:this.groupId
        //     }).then(function(resp){
        //         if(resp.data.code=='200'){
        //             var data = resp.data.data.person
        //             if(data){
        //                 that.form = data
        //                 that.form.teamLeader = data.teamManagerFlag=='1'?true:false
        //                 that.form.name = data.personName
        //                 that.form.facePhoto = base.httpCtx+data.facePhoto+'?v='+new Date().getTime()
        //                 that.form.idcardPhoto = base.httpCtx+data.idcardPhoto
        //                 that.getTeamList()
        //                 // setTimeout(function(){
        //                 //     that.teamsFilter()
        //                 // },100)
        //             }
        //         }
        //     })
        // },
      
        

        //下载驱动
        downDrive(command){
            // if(this.form.mach==1){
            //     window.open('http://filesites.tongsheng01.com/static/wisdom/plug/华视二代证读写机USB驱动.exe','one')
            //     window.open('http://filesites.tongsheng01.com/static/wisdom/plug/身份证阅读器驱动.rar','two')
            // }
            if(command=='a'){
                window.open('https://file49.tongsheng01.com/static/wisdom/plug/华视二代证读写机USB驱动.exe','one')
            }else if(command=='b'){
                window.open('https://file49.tongsheng01.com/static/wisdom/plug/身份证阅读器驱动.rar','two')
            }else if(command=='c'){
                window.open('https://file49.tongsheng01.com/static/wisdom/plug/身份证识别机使用说明.docx')
            }
        },

        // 身份证下载驱动
        sfzDownDrive(){
           window.open('https://file49.tongsheng01.com/static/wisdom/plug/身份证读卡器驱动.zip')
        },

         ajax(options) {
          if(options.type==null)
          {
            options.type="POST";
          }
          
          if(options.url==null)
          {
            options.url="";
          }
          
          if(options.timeout==null)
          {
            options.timeout=5000;
          }
          
          if(options.onComplate==null)
          {
            options.onComplate=function() 
            {
            }
          }
          
          if(options.onError==null)
          {
            options.onError=function() 
            {
            }
          }
          
          if(options.onSuccess==null)
          {
            options.onSuccess=function() 
            {
            }
          }
          
          if(options.data)
          {
            options.data="";
          }

          var xml ;	
          if (typeof ActiveXObject != 'undefined') {
          var aVersions = ["Microsoft.XMLHTTP", "Msxml2.XMLHttp.6.0", "Msxml2.XMLHttp.5.0", "Msxml2.XMLHttp.4.0", "Msxml2.XMLHttp.3.0"];
          for (var i = 0; i < aVersions.length; i++) {
            try {
              xml = new ActiveXObject(aVersions[i]);
              }catch (e) {}
            }
          } else if (typeof XMLHttpRequest != 'undefined'){
            xml = new XMLHttpRequest();
          }

          xml.open(options.type, options.url, true);
          
          var timeoutLength = options.timeout;
          
          var requestDone = false;
          
          setTimeout(function() {
                requestDone = true;
              }, timeoutLength);
              
          xml.onreadystatechange = function() {
          
            if (xml.readyState == 4 && !requestDone) {
            
              if (httpSuccess(xml)) {
              
                options.onSuccess(httpData(xml));
              }
              
              else {
                options.onError();
              }
              
              options.onComplate();
              
              xml = null;
            }
          };

          xml.send();

          function httpSuccess(r) {
            try {
              return !r.status && location.protocol == "file:"
                  ||
                  (r.status >= 200 && r.status <= 300)
                  ||
                  r.status == 304
                  ||

                  navigator.userAgent.indexOf("Safari") >= 0
                  && typeof r.status == "undefined";
            } catch (e) {
            }
            return false;
          }
          
          function httpData(r) {
            var ct = r.getResponseHeader("responseType");
            if(ct)
            {
              if(ct=="script")
              {
                eval.call(window, data);
              }
              if(ct=="xml")
              {
                return r.responseXML;
              }
              if(ct=="json")
              {
                return JSON.parse(r.responseText);
              }
            }
            return r.responseText;
          }
        },
        

        //读取身份证
        readCard(){
            var that = this
            console.log('读取身份证！')
            myHttp.getIdcard('http://localhost:8099/?cmd=readcardnomal&charset=utf8').then(function(resp){
                if(resp.errorMsg=='success'){
                    that.form.name = resp.resultContent.partyName
                    that.form.idCard = resp.resultContent.certNumber            
                    that.form.address = resp.resultContent.certAddress
                    that.form.startDate = that.filterDate(resp.resultContent.effDate)
                    that.form.endDate = that.filterDate(resp.resultContent.effDate)
                    // that.form.endDate = resp.resultContent.expDate && resp.resultContent.expDate!='长期'?that.filterDate(resp.resultContent.expDate):'长期'
                    that.form.idCardPhoto64 = resp.resultContent.identityPic
                }else{
                    that.$message.error('设备连接失败！')
                }
            })
        },

        readCardNew(){
          let that = this
          function onSuccess(data){
              console.log(data);
              if(data.match("\"resultFlag\" : (.*)")[1] == 0){
                that.readCard2()
              }else{
                that.$message.error(data.match("\"errorMsg\" : (.*)")[1].substr(1, data.match("\"errorMsg\" : (.*)")[1].length - 3))
              }
            }
          var options=new Object();
          options.type="GET";
          //options.url = "/OpenDevice";
          options.url = "http://127.0.0.1:19196/OpenDevice";
          options.timeout=5000;
          options.onSuccess=onSuccess;
          this.ajax(options);
        },

        readCard2(){
          let that = this
            function onSuccess(data){
              console.log(data);
              if(data.match("\"resultFlag\" : (.*)")[1] != 0){
                that.$message.error(data.match("\"errorMsg\" : (.*)")[1].substr(1, data.match("\"errorMsg\" : (.*)")[1].length - 3))
                return false
              }
              that.$message.success(data.match("\"errorMsg\" : (.*)")[1].substr(1, data.match("\"errorMsg\" : (.*)")[1].length - 3))
              var endDt = new Date();
              // document.getElementById("timeElapsed").value = (endDt.getTime() - startDt.getTime()) + "毫秒";
              var errorMsg = data.match("\"errorMsg\" : (.*)")[1];
              var resultFlag = data.match("\"resultFlag\" : (.*)")[1];
              that.form.name = data.match("\"partyName\" : \"(.*?)\"")[1]
              that.form.idCard = data.match("\"certNumber\" : \"(.*?)\"")[1]
            //   that.form.sex = data.match("\"gender\" : \"(.*?)\"")[1] == '男'? 1 : (data.match("\"gender\" : \"(.*?)\"")[1] == '女'? 0 : '')
            //   that.form.sexName = data.match("\"gender\" : \"(.*?)\"")[1]
            //   that.form.nation = data.match("\"nation\" : \"(.*?)\"")[1]
            //   that.form.birthday = that.filterDate(data.match("\"bornDay\" : \"(.*?)\"")[1])
              that.form.issuing = data.match("\"certOrg\" : \"(.*?)\"")[1]
              that.form.address = data.match("\"certAddress\" : \"(.*?)\"")[1]
            //   that.form.startDate = that.filterDate(data.match("\"effDate\" : \"(.*?)\"")[1])
            //   that.form.endDate = that.filterDate(data.match("\"effDate\" : \"(.*?)\"")[1])
            //   that.form.endDate = data.match("\"expDate\" : \"(.*?)\"")[1] && data.match("\"expDate\" : \"(.*?)\"")[1]!='长期'?that.filterDate(data.match("\"expDate\" : \"(.*?)\"")[1]):'长期'
              that.form.idCardPhoto64 = data.match("\"identityPic\" : \"(.*?)\"")[1]
            }
            var startDt = new Date();
            var options=new Object();
            options.type="GET";
            //options.url="readcard";
            options.url = "http://127.0.0.1:19196/readcard";
            options.timeout=5000;
            options.onSuccess=onSuccess;
            that.ajax(options);
        },

        //时间
        filterDate(datetime){
            var result = ''
            if(datetime && datetime!=''){
                var list = datetime.split('')
                result = list[0]+list[1]+list[2]+list[3]+'-'+list[4]+list[5]+'-'+list[6]+list[7]
            }
            return result
        },
   
        //提交
        submitForm(formName){
            if(this.isSubmit){
                return
            }
            this.isSubmit = true
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    var that = this
                    // this.form.creatBy = util.session.get('user').id
                    this.form.projectId = this.groupId
                    this.form.name = this.form.name
                    // this.form.cardNumber = this.form.icCard
                    this.form.phone = this.form.phone
                    this.form.idCard = this.form.idCard
                    that.form.endDate = that.form.endDate ==''?'长期':that.form.endDate
                    that.form.startDate = that.form.startDate ==''?'长期':that.form.startDate
                    this.form.idCardPhoto= this.form.idCardPhoto64 ==''?this.form.facePhoto64:this.form.idCardPhoto64
                    this.form.facePhoto=this.form.facePhoto64
                     
                        myHttp.addVisVisitor(JSON.stringify(this.form)).then(function(resp){
                           
                            if(resp.data.code=='200'){
                                that.$message.success('录入成功')
                                // that.getVisVisitorPage()
                               that.$router.push({path:'/visitorPro'})
                            }else{
                                that.$message.error(resp.data.msg)
                            }
                            that.isSubmit = false
                        },function(){ that.isSubmit = false})
                    // }else{
                        
                    //     delete this.form.facePhoto
                    //     delete this.form.idCardPhoto
                        // myHttp.putProjectPerson(JSON.stringify(this.form)).then(function(resp){
                        //     if(resp.data.code=='200'){
                        //         that.$message.success('修改成功')
                        //         that.$router.go(-1)
                        //     }else{
                        //         that.$message.error(resp.data.msg)
                        //     }
                        //     that.isSubmit = false
                        // },function(){ that.isSubmit = false})
                    // }
                } else {
                    this.isSubmit = false
                    return false;
                }
            });
        },

        getFile (file, fileList) {
            var that = this
            // console.log(file)
            if(file.raw.type!='image/jpeg'&&file.raw.type!='image/jpg'){
                this.$message.error('上传图片需要是JPG格式')
                return;
            }
            this.getBase64(file.raw).then(res => {
                that.form.facePhoto64 = res
                // that.form.facePhoto = ''
                // console.log(that.form.facePhoto64)
            })
        },
        getBase64 (file) {
            return new Promise(function (resolve, reject) {
                let reader = new FileReader()
                let imgResult = ''
                reader.readAsDataURL(file)
                reader.onload = function () {
                    imgResult = reader.result
                }
                reader.onerror = function (error) {
                    reject(error)
                }
                reader.onloadend = function () {
                    resolve(imgResult)
                }
            })
        },
        fileSuccess(res,file){

        },

        //拍照弹出框
        photoFun(){
            var that = this
            this.photoImg = require('../../assets/image/guifan_files/camerTip.png')
            this.photoVis = true
            setTimeout(function(){
                // 老的浏览器可能根本没有实现 mediaDevices，所以我们可以先设置一个空的对象
                if (navigator.mediaDevices === undefined) {
                    navigator.mediaDevices = {};
                }
                if (navigator.mediaDevices.getUserMedia === undefined) {
                    navigator.mediaDevices.getUserMedia = function (constraints) {
                        // 首先，如果有getUserMedia的话，就获得它
                        var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
    
                        if (!getUserMedia) {
                            return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
                        }
    
                        // 否则，为老的navigator.getUserMedia方法包裹一个Promise
                        return new Promise(function (resolve, reject) {
                            getUserMedia.call(navigator, constraints, resolve, reject);
                        });
                    }
                }
                const constraints = {
                    video: true,
                    audio: false
                };
                console.log(that.video)
                if(!that.video){
                    that.video = document.getElementById('v');
                }
                let promise = navigator.mediaDevices.getUserMedia(constraints);
                promise.then(stream => {
                    // 旧的浏览器可能没有srcObject
                    if ("srcObject" in that.video) {
                        that.video.srcObject = stream;
                    } else {
                        // 防止再新的浏览器里使用它，应为它已经不再支持了
                        that.video.src = window.URL.createObjectURL(stream);
                    }
                    v.onloadedmetadata = function (e) {
                        that.video.play();
                        that.videoPlaying = true;
                    };
                    console.log(that.video)
                }).catch(err => {
                    console.error(err)
                    that.$message.error('请链接摄像头！')
                })
            },100)
            
        },

        takePhotos(){
            if (this.videoPlaying) {
                let canvas = document.getElementById('canvas');
                canvas.width = 640;
                canvas.height = 480;
                canvas.getContext('2d').drawImage(this.video, 0, 0);
                let data = canvas.toDataURL('image/webp');
                this.photoImg = data
            }else{
                this.$message.error('请链接摄像头！')
            }
        },
        //提交
        photoSubmit(){
            if (this.videoPlaying) {
                this.form.facePhoto64 = this.photoImg
                this.photoImg = ''
                this.photoVis = false
            }else{
                this.$message.error('请链接摄像头！')
            }
        },

    }
}
</script>

<style scoped>
    .info-box{
        width: 100%;
        height: 100%;
        position: relative;
        padding:0 1vh;
    }
    .box-head{
        width: 100%;
        height: 1vh;
        position: relative;
        background: #fff;
        padding-top: 2vh;
    }
    .box-main{
        width: 100%;
        height: calc( 100% - 5vh );
        position: relative;
        background: #fff;
        overflow: auto;
    }
    
    .type-item{
        color:#3e50b4;
        margin:0 0.5vh 0.5vh 0;
        font-size:0.8vw;
        cursor: pointer;
        height: 3vh;
        line-height: 3vh;
        padding: 0 1vh;
        border-radius: 2px;
    }
    .type-item:hover{
        color: #409eff;
       
    }
    .selIndex{
        background: #409eff;
        color: #fff;
    }
    .selIndex:hover{
        color: #fff;
    }
    .msgitem{
   
    margin-left: 18px;
    }
</style>

<style>
    @import '../../assets/css/common.css';
    .box-main .el-form-item__content{
        text-align: left;
    }
    .el-date-editor .el-range-separator{
        width: 2vw;
    }
    .work-add .el-input__inner,.work-add .el-select .el-input{
        width: 350px;
        max-width: 350px;
    }
    .work-add .youxiao .el-input__inner{
        width: 150px;
        max-width: 150px;
    }
    .work-add .el-input.is-disabled .el-input__inner{
        background-color:#fff;
        color: #606266;
    }
    .photoBtn i{
        color:#409EFF;
    }
    .photoBtn span{
        top: -3px;
    }
    .dialog-photo .el-dialog__header{
        border-bottom: 1px solid #409EFF;
    }
</style>